import { createContext, useState } from "react";

export const AppointmentContext = createContext();

const AppointmentContextProvider = ({ children }) => {
  const [appointments, setAppointments] = useState([]);

  // Fetch all appointments (simulate API call)
  const fetchAppointments = async () => {
    // Replace with real API call
    // const data = await api.getAppointments();
    // setAppointments(data);
    return appointments;
  };

  // Add a new appointment
  const addAppointment = (appointment) => {
    setAppointments(prev => [...prev, appointment]);
  };

  // Update an appointment by id
  const updateAppointment = (id, updated) => {
    setAppointments(prev => prev.map(app => app.id === id ? { ...app, ...updated } : app));
  };

  // Remove an appointment by id
  const removeAppointment = (id) => {
    setAppointments(prev => prev.filter(app => app.id !== id));
  };

  return (
    <AppointmentContext.Provider value={{
      appointments,
      setAppointments,
      fetchAppointments,
      addAppointment,
      updateAppointment,
      removeAppointment
    }}>
      {children}
    </AppointmentContext.Provider>
  );
};

export { AppointmentContextProvider };
